export default "__VITE_ASSET__DLz4qYx1__"